import FORM_STATE from '../../../constants/formStateConstants';

// Takes
// (i) predicateOperator - string symbol of logical comparison operation
// (ii) predicateTargetVal - current value taken from store
// (iii) predicateOperand - Array or individual value that satisfies comparator
// (iv) predicateKeyVal - string key of predicate object
// Returns a boolean expression based on respective values of each
const translatePredicateOptions = (predicateDescriptor: any) => {
  switch (predicateDescriptor.predicateOperator) {
    case '=':
      return (
        predicateDescriptor.predicateTargetVal ===
          predicateDescriptor.predicateOperand ||
        predicateDescriptor.predicateOperand.includes(
          predicateDescriptor.predicateTargetVal
        )
      );
    case '!=':
      return (
        predicateDescriptor.predicateTargetVal !==
          predicateDescriptor.predicateOperand &&
        !predicateDescriptor.predicateOperand.includes(
          predicateDescriptor.predicateTargetVal
        )
      );
    case '>':
      if (predicateDescriptor.predicateKeyVal === FORM_STATE.birthdate) {
        return (
          Date.parse(predicateDescriptor.predicateTargetVal) >
          Date.parse(predicateDescriptor.predicateOperand)
        );
      }
      return (
        predicateDescriptor.predicateTargetVal >
        predicateDescriptor.predicateOperand
      );
    case '<':
      if (predicateDescriptor.predicateKeyVal === FORM_STATE.birthdate) {
        return (
          Date.parse(predicateDescriptor.predicateTargetVal) <
          Date.parse(predicateDescriptor.predicateOperand)
        );
      }
      return (
        predicateDescriptor.predicateTargetVal <
        predicateDescriptor.predicateOperand
      );
    case '<=':
      if (predicateDescriptor.predicateKeyVal === FORM_STATE.birthdate) {
        return (
          Date.parse(predicateDescriptor.predicateTargetVal) <=
          Date.parse(predicateDescriptor.predicateOperand)
        );
      }
      return (
        predicateDescriptor.predicateTargetVal <=
        predicateDescriptor.predicateOperand
      );
    case '>=':
      if (predicateDescriptor.predicateKeyVal === FORM_STATE.birthdate) {
        return (
          Date.parse(predicateDescriptor.predicateTargetVal) >=
          Date.parse(predicateDescriptor.predicateOperand)
        );
      }
      return (
        predicateDescriptor.predicateTargetVal >=
        predicateDescriptor.predicateOperand
      );
    default:
      return (
        predicateDescriptor.predicateTargetVal ===
          predicateDescriptor.predicateOperand ||
        predicateDescriptor.predicateOperand.includes(
          predicateDescriptor.predicateTargetVal
        )
      );
  }
};

// Takes current state and step descriptors
// If show_if object is present on each, determines if
// required predicate is satisfied for all included show_if object key-value pairs.
// If so, adds 'true' show_boolean to field object
// if not, adds 'false show_boolean to field object
const decorateFieldWithShowIf = (
  steps: any,
  formState: any,
  currentVisitorType: string
) => {
  // Set visitor type by api data if not set locally
  if (!formState.visitortype && currentVisitorType) {
    formState['visitortype'] = currentVisitorType; //eslint-disable-line
  }
  return steps.map((step: any) => {
    const { fields } = step;
    const decoratedFields = fields.map((field: any) => {
      let showBoolean = true;
      if (!field.show_if) {
        return { showBoolean, ...field };
      }
      const parsedShowIf = JSON.parse(field.show_if);
      // if no show_if array, keep step in
      if (!parsedShowIf || Array.isArray(parsedShowIf)) {
        showBoolean = true;
      } else if (Object.keys(parsedShowIf).length === 0) {
        showBoolean = true;
      } else {
        // Collect boolean values for all show_if key-value pairs
        const predicateArray: any = [];
        Object.keys(parsedShowIf).forEach(predicateKey => {
          const predicateKeyArray = predicateKey.split(' ');
          const predicateKeyVal = predicateKeyArray[0];
          if (!formState[predicateKeyArray[0]]) {
            // don't want true default if State (location) not present
            if (predicateKeyVal === FORM_STATE.state) {
              predicateArray.push(false);
            } else {
              // otherwise default to true if formstate not present
              predicateArray.push(true);
            }
          } else {
            const predicateTargetVal = formState[predicateKeyArray[0]];
            const predicateOperator = predicateKeyArray[1];
            const predicateOperand = parsedShowIf[predicateKey];
            predicateArray.push(
              translatePredicateOptions({
                predicateTargetVal,
                predicateOperator,
                predicateOperand,
                predicateKeyVal,
              })
            );
          }
        });

        // Reduce collected boolean values to a single boolean to determine if step remains
        showBoolean = predicateArray.reduce(
          (predicateBoolean: boolean, reducedBooleanExpression: boolean) => {
            return predicateBoolean && reducedBooleanExpression;
          },
          true
        );
      }
      return { ...field, showBoolean };
    });
    return Object.assign(step, { fields: decoratedFields });
  });
};
export default decorateFieldWithShowIf;
